import * as React from "react";
import {AccountPageWrapper} from "components/account/widgets/AccountPageWrapper";
import {AccountContentContainer} from "components/account/widgets/AccountContentContainer";
import {action, observable} from "mobx";
import {observer} from "mobx-react";
import {IAccountPage, AccountPages} from "components/account/Account";
import {DashboardSolution} from "data/entities/DashboardSolution";
import {AccountSubContainer} from "components/account/widgets/AccountSubContainer";
import DashboardData from "data/DashboardData";

import './AccountRemoveParticipationConfirm.pcss';

interface Props {
  onChangeAccountPage:(page:IAccountPage) => void;
  dashboardSolution: DashboardSolution;
}

export function AccountRemoveParticipationConfirm(props: Props) {

  function cancel() {
    props.onChangeAccountPage(AccountPages.AccountParticipation);
  }

  return (
    <AccountPageWrapper
      title={"Remove Participation"}
      backOrCloseAction={cancel}
      backOrCloseLabel={"Back to Participation Settings"}
    >
      <AccountContentContainer>

        <RemoveParticipationConfirm onCancel={cancel} dashboardSolution={props.dashboardSolution} />

      </AccountContentContainer>
    </AccountPageWrapper>
  );

}


@observer
class RemoveParticipationConfirm extends React.Component<{onCancel:()=>void, dashboardSolution:DashboardSolution}> {
  @observable password:string;
  @observable deleting:boolean = false;
  @observable error:boolean = false;
  @observable iunderstand = false;

  handleCancel = () => {
    this.password = '';
    this.deleting = false;
    this.props.onCancel();
  }

  // TODO: Allow 3 attempts then log the user out
  attemptRemoveParticipation = () => {
    if(!this.password || !this.iunderstand) {
      alert('Your password and consent are required to remove your participation.');
    } else {
      if(!this.deleting) {
        this.deleting = true;
        DashboardData.removeDashboardSolution(this.props.dashboardSolution, this.password)
          .then(action(()=>{
            this.handleCancel();
          }))
          .catch(action((err) => {
            alert("Failed to remove participation. Please try again or contact strive@well-concepts.com for help.");
            this.deleting = false;
          }))
      }
    }
  }

  render() {
    return(
      <>
        <h2 className={"level2"}>Remove participation in {this.props.dashboardSolution.name}?</h2>

        <div>
          <p>If you remove participation:</p>
            <ul>
              <li>you will no longer receive emails for this program</li>
              <li>your Zoom webinar participation will be canceled</li>
              <li>your points for the program will be removed and any badge you may have earned</li>
              <li>your participation will be removed from reporting</li>
            </ul>
        </div>

        {this.error &&
          <p className="error">There was a problem trying to remove participation. Please try again. If the problem persists, please
            contact Wellness Concepts support for help using <a href="mailto:strive@well-concepts.com">strive@well-concepts.com</a>.</p>
        }

        <AccountSubContainer>
          <div className="material-cbx">
            <button id='iunderstand' name='iunderstand' onClick={action(()=>{ this.iunderstand = !this.iunderstand })} aria-label='I understand any of my activity in the program will be removed'>
              <span className="material-icons">{this.iunderstand ? 'check_box' : 'check_box_outline_blank'}</span>
            </button>
            <label htmlFor={'iunderstand'} onClick={action(()=>{ this.iunderstand = !this.iunderstand })} aria-hidden={true} className={'noselect'}>I understand any of my activity in the program will be removed</label>
          </div>
        </AccountSubContainer>

        <fieldset>
          <label htmlFor={"confirmbox2"} >Confirm by entering your password</label>
          <input data-op-ignore={true} style={{maxWidth:'390px'}} id="confirmbox2" name="confirmbox2" disabled={this.deleting} value={this.password} onChange={(e)=>{ this.password = e.target.value; }} placeholder="Password" type="password"/><br/>
        </fieldset>

        <div className="action-buttons">
          <div className={"spacer"}></div>
          <button className={"secondary"} onClick={this.handleCancel}>Cancel</button>
          <button className={"primary"} onClick={this.attemptRemoveParticipation}>Remove Participation</button>
        </div>

      </>
    );
  }
}

